<template>
  <div class="app-wrapper">
    <!-- 导航栏 -->
    <Header></Header>
    <!-- 内容区域 -->
    <div class="main" :class="{ hiddenHeader: $route.meta.hideTitle === true }">
      <div class="content">
        <router-view />
      </div>
    </div>
    <!-- 底部栏 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './components/Header';
import Footer from './components/Footer';

export default {
  components: {
    Header,
    // Sidebar,
    Footer,
  },
};
</script>

<style lang="less" scoped>
.main {
  min-height: calc(100vh - 80px);
  margin: 80px auto 0;
  padding: 24px 20px 20px;
  &.hiddenHeader {
    min-height: 100vh;
    margin-top: 0;
    padding: 0;
  }
}

.content {
  font-size: 24px;
  line-height: 1.5;
  color: #262626;
  overflow: visible;
}
</style>
